import { render, staticRenderFns } from "./LogManagement.vue?vue&type=template&id=9dfbcdd2&"
import script from "./LogManagement.vue?vue&type=script&lang=js&"
export * from "./LogManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports